
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMotionTrueIec as ObiMotionTrueIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-motion-true-iec.js';
 
 
 

 
 export const ObiMotionTrueIec = createComponent({
   react: React,
   tagName: 'obi-motion-true-iec',
   elementClass: ObiMotionTrueIecElement,
   events: {
     
   }
  });
 
 